import * as React from 'react';
import { Link } from 'react-router-dom';

import { ArrowIcon } from '@/components/pulse/icons';

export interface PersonCardData {
  readonly displayName: string;
  readonly initials: string;
  readonly avatarColour: string;
  readonly roleLine: string;
  readonly merged: number;
  readonly openPullRequests: number | null;
  readonly reviewed: number;
  readonly lines: ReadonlyArray<string>;
  readonly note: string | null;
  readonly href: string;
}

/**
 * The prototype's `personCard()`: name and role, the day's Merged, Open PRs and Reviewed, up to
 * three lines on what they did, and their blockers note (TOD-3).
 */
export function PersonCard({ person }: { readonly person: PersonCardData }): React.ReactElement {
  return (
    <article className="card pcard">
      <div className="row" style={{ gap: 12 }}>
        <span className="avatar" style={{ background: person.avatarColour }}>
          {person.initials}
        </span>
        <div className="stack" style={{ gap: 2, flexGrow: 1, minWidth: 0 }}>
          <span style={{ fontSize: 16, fontWeight: 600 }}>{person.displayName}</span>
          <span className="sub" style={{ fontSize: 13 }}>
            {person.roleLine}
          </span>
        </div>
        <Link className="linkish" to={person.href} style={{ fontSize: 13 }}>
          Open day <ArrowIcon />
        </Link>
      </div>
      <div className="pstats num">
        <div className="pstat">
          <b>{person.merged}</b>
          <span>Merged</span>
        </div>
        <div className="pstat">
          <b>{person.openPullRequests ?? '–'}</b>
          <span>Open PRs</span>
        </div>
        <div className="pstat">
          <b>{person.reviewed}</b>
          <span>Reviewed</span>
        </div>
      </div>
      {person.lines.length > 0 ? (
        <ul className="plist">
          {person.lines.map((line) => (
            <li key={line}>{line}</li>
          ))}
        </ul>
      ) : (
        <span style={{ color: 'var(--muted)' }}>Nothing merged or built this day.</span>
      )}
      <div className="note">
        <span style={{ fontWeight: 600 }}>Blockers and tomorrow</span>
        <span style={{ color: person.note === null ? 'var(--muted)' : 'var(--ink)' }}>{person.note ?? 'Not added yet'}</span>
      </div>
    </article>
  );
}
